import {
  Exchange,
  exchangeToJSON,
  TradeVenue,
  tradeVenueToJSON,
} from '@/types/generated/common/types'

/** 'EXCHANGE_DERIBIT' → 'deribit'. Undefined when unspecified/unknown. */
export function exchangeName(exchange: Exchange | undefined): string | undefined {
  if (exchange === undefined || exchange === Exchange.EXCHANGE_UNSPECIFIED) return undefined
  const json = exchangeToJSON(exchange)
  if (!json.startsWith('EXCHANGE_') || json === 'UNRECOGNIZED') return undefined
  return json.slice('EXCHANGE_'.length).toLowerCase()
}

/** 'TRADE_VENUE_DERIBIT' → 'deribit'. Undefined when unspecified/unknown. */
export function tradeVenueName(venue: TradeVenue | undefined): string | undefined {
  if (venue === undefined || venue === TradeVenue.TRADE_VENUE_UNSPECIFIED) return undefined
  const json = tradeVenueToJSON(venue)
  if (!json.startsWith('TRADE_VENUE_') || json === 'UNRECOGNIZED') return undefined
  return json.slice('TRADE_VENUE_'.length).toLowerCase()
}
